import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './footer/footer.component';
import { NavigationComponent } from './navigation/navigation.component';
import { DropdownDirective } from './navigation/dropdown.directive';
import { NotFoundComponent } from './not-found/not-found.component';
import { CollapseDirective } from './navigation/collapse.directive';



@NgModule({
  declarations: [
    FooterComponent,
    NavigationComponent,
    DropdownDirective,
    NotFoundComponent,
    CollapseDirective
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [FooterComponent,
    NavigationComponent,
    DropdownDirective,
    NotFoundComponent,
    CollapseDirective]
})
export class SharedModule { }
